<template>
  <hr class="my-6 -mx-6 border-t border-gray-200 dark:border-gray-700">
</template>
